import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
`;
